import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DelayingAppearance from './DelayingAppearance';
import ClientProvider from './client';
export default createDemo(import.meta.url, DelayingAppearance, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/progress/demos/delaying-appearance/DelayingAppearance.tsx",
    "fileName": "DelayingAppearance.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Fade from '@mui/material/Fade';\nimport Button from '@mui/material/Button';\nimport CircularProgress from '@mui/material/CircularProgress';\nimport Typography from '@mui/material/Typography';\n\nexport default function DelayingAppearance() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [loading, setLoading] = React.useState(false);\n  const [query, setQuery] = React.useState('idle');\n  const timerRef = React.useRef<ReturnType<typeof setTimeout>>(undefined);\n\n  React.useEffect(\n    () => () => {\n      clearTimeout(timerRef.current);\n    },\n    [],\n  );\n\n  const handleClickLoading = () => {\n    setLoading((prevLoading) => !prevLoading);\n  };\n\n  const handleClickQuery = () => {\n    if (timerRef.current) {\n      clearTimeout(timerRef.current);\n    }\n\n    if (query !== 'idle') {\n      setQuery('idle');\n      return;\n    }\n\n    setQuery('progress');\n    timerRef.current = setTimeout(() => {\n      setQuery('success');\n    }, 2000);\n  };\n\n  return (\n    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>\n      <Box sx={{ height: 40 }}>\n        <Fade\n          in={loading}\n          style={{\n            transitionDelay: loading ? '800ms' : '0ms',\n          }}\n          unmountOnExit\n        >\n          <CircularProgress aria-label=\"Loading…\" />\n        </Fade>\n      </Box>\n      <Button onClick={handleClickLoading} sx={{ m: 2 }}>\n        {loading ? 'Stop loading' : 'Loading'}\n      </Button>\n      <Box sx={{ height: 40 }}>\n        {query === 'success' ? (\n          <Typography>Success!</Typography>\n        ) : (\n          <Fade\n            in={query === 'progress'}\n            style={{\n              transitionDelay: query === 'progress' ? '800ms' : '0ms',\n            }}\n            unmountOnExit\n          >\n            <CircularProgress aria-label=\"Loading…\" />\n          </Fade>\n        )}\n      </Box>\n      <Button onClick={handleClickQuery} sx={{ m: 2 }}>\n        {query !== 'idle' ? 'Reset' : 'Simulate a load'}\n      </Button>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 76,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Fade from '@mui/material/Fade';\nimport Button from '@mui/material/Button';\nimport CircularProgress from '@mui/material/CircularProgress';\nimport Typography from '@mui/material/Typography';\n\nexport default function DelayingAppearance() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [loading, setLoading] = React.useState(false);\n  const [query, setQuery] = React.useState('idle');\n  const timerRef = React.useRef<ReturnType<typeof setTimeout>>(undefined);\n\n  React.useEffect(\n    () => () => {\n      clearTimeout(timerRef.current);\n    },\n    [],\n  );\n\n  const handleClickLoading = () => {\n    setLoading((prevLoading) => !prevLoading);\n  };\n\n  const handleClickQuery = () => {\n    if (timerRef.current) {\n      clearTimeout(timerRef.current);\n    }\n\n    if (query !== 'idle') {\n      setQuery('idle');\n      return;\n    }\n\n    setQuery('progress');\n    timerRef.current = setTimeout(() => {\n      setQuery('success');\n    }, 2000);\n  };\n\n  return (\n    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>\n      <Box sx={{ height: 40 }}>\n        <Fade\n          in={loading}\n          style={{\n            transitionDelay: loading ? '800ms' : '0ms',\n          }}\n          unmountOnExit\n        >\n          <CircularProgress aria-label=\"Loading…\" />\n        </Fade>\n      </Box>\n      <Button onClick={handleClickLoading} sx={{ m: 2 }}>\n        {loading ? 'Stop loading' : 'Loading'}\n      </Button>\n      <Box sx={{ height: 40 }}>\n        {query === 'success' ? (\n          <Typography>Success!</Typography>\n        ) : (\n          <Fade\n            in={query === 'progress'}\n            style={{\n              transitionDelay: query === 'progress' ? '800ms' : '0ms',\n            }}\n            unmountOnExit\n          >\n            <CircularProgress aria-label=\"Loading…\" />\n          </Fade>\n        )}\n      </Box>\n      <Button onClick={handleClickQuery} sx={{ m: 2 }}>\n        {query !== 'idle' ? 'Reset' : 'Simulate a load'}\n      </Button>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 76,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Fade",
      "@mui/material/Button",
      "@mui/material/CircularProgress",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
